import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Input, Button, message, Modal } from 'antd';
import { AlertFilled } from '@ant-design/icons';
import store from 'store';
import JSEncrypt from 'jsencrypt';

import './AccountLogin.styl';
import { getPublicKey } from '@/api/login';
import { userTenantLogin } from '@/api/tenant';
import { hrefHomeByToken, checkIsLaunchpad } from '@/utils/util';
import ForgetPassword from '@/components/ForgetPassword/ForgetPassword';
import DefaultPassword from '../../components/DefaultPassword/DefaultPassword';
import UserName from '@/assets/images/user-name.png';
import UserPsd from '@/assets/images/user-psd.png';

class AccountLogin extends Component {
  state = {
    visible: false,
    validCodeRequired: false, // 是否要填写验证码
    visibleDefaultPassword: false,
    loading: false,
    loginParams: {
      account: '',
      password: '',
      verificationCode: '', // 验证码
    },
    propsKeyDownNum: null,
  };

  render() {
    return (
      <div className="account-login">
        <Input
          placeholder="请输入锐锢工号/手机号"
          className="input-back"
          prefix={<img alt="logo" className="login-icon" src={UserName} />}
          onChange={this.changeAccount}
        />
        <Input.Password
          className="m-t-10 input-back"
          placeholder="请输入密码"
          prefix={<img alt="logo" className="login-icon" src={UserPsd} />}
          onChange={this.changePassword}
        />
        {/* verificationCode */}
        {this.state.validCodeRequired && (
          <Input
            placeholder="验证码"
            className="m-t-10 input-back"
            prefix={<AlertFilled style={{ fontSize: 15, color: '#fe5023' }} />}
            onChange={this.changeValidCode}
          />
        )}

        <div className='login-btn-box'>
          <Button
            type="primary"
            className="login-btn w-300"
            loading={this.state.loading}
            onClick={this.handleAccountLogin}
          >
            登录
          </Button>
          {checkIsLaunchpad() && (
            <span
              className="forget-password flex-row-center-center pointer"
              onClick={this.handleShowForgetPassword}
            >
              忘记密码?
            </span>
          )}
        </div>
        <ForgetPassword
          visible={this.state.visible}
          handleCloseModal={(visible) => this.handleCloseModal(visible)}
        />
        <DefaultPassword
          visible={this.state.visibleDefaultPassword}
          user={this.state.loginParams.account}
          handleCloseDefaultPasswordModal={(visible) =>
            this.handleCloseDefaultPasswordModal(visible)
          }
        />
      </div>
    );
  }

  // 忘记密码
  handleShowForgetPassword = () => {
    this.setState({
      visible: true,
    });
  };
  handleCloseModal = (visible) => {
    this.setState({ visible });
  };
  handleCloseDefaultPasswordModal = (visibleDefaultPassword) => {
    this.setState({ visibleDefaultPassword });
  };

  // account改变
  changeAccount = ({ target: { value } }) => {
    this.setState({
      loginParams: {
        ...this.state.loginParams,
        account: value,
      },
    });
  };
  // password改变
  changePassword = ({ target: { value } }) => {
    this.setState({
      loginParams: {
        ...this.state.loginParams,
        password: value,
      },
    });
  };

  /**
   * @description: 验证码改变
   * @param {*} target
   */
  changeValidCode = ({ target: { value } }) => {
    this.setState({
      loginParams: {
        ...this.state.loginParams,
        verificationCode: value,
      },
    });
  };

  /**
   * 账号密码登录
   */
  handleAccountLogin = async () => {
    if (this.state.loginParams.account === '') {
      message.warning('账号不能为空');
      return;
    }
    if (this.state.loginParams.password === '') {
      message.warning('密码不能为空');
      return;
    }
    this.setState({ loading: true });

    // 加密
    const publicKey = await getPublicKey();
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    const username = this.state.loginParams.account;
    const password = encryptor.encrypt(this.state.loginParams.password);

    userTenantLogin({
      username,
      password,
      verificationCode: this.state.validCodeRequired
        ? this.state.loginParams.verificationCode
        : undefined,
      publicKey,
      grantType: 'password',
      scope: 'server',
      // client_id: 'client_2',
      // client_secret: 'abcd',
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET
    })
      .then((res) => {
        this.setState({ loading: false });
        if (res.code === 4002003) {
          Modal.warning({
            className: 'comon-modal-body',
            okText: '确认',
            title: res.message || '当前密码已过期，请重置密码后再登录',
            onOk: () => {
              this.handleShowForgetPassword();
            },
          });
          return;
        }
        const { token, bizOrgList, userIdentity } = res;
        if (token && token.access_token) {
          hrefHomeByToken(token.access_token, bizOrgList, userIdentity, this.props.history);
        } else {
          const messageInfo = res.message,
            code = res.code;
          if (code === 4001028) {
            // 需要验证码
            this.setState({
              validCodeRequired: true, // 验证码
            });
            message.warning(
              '验证码已经发送到您的手机上，请输入验证码后再次登陆！',
            );
            return;
          }
          if (code === 4001021) {
            this.setState({
              visibleDefaultPassword: true, // 首次登录修改默认密码
            });
            return;
          }
          store.clearAll();
          message.error(messageInfo);
        }
      })
      .catch((e) => {
        store.clearAll();
        this.setState({ loading: false });
        message.error(e.message || '登录失败');
      });
  };

  // 父级window监听键盘回车事件
  componentWillReceiveProps({ propsKeyDownNum, checkIndex }) {
    if (checkIndex === 0 && propsKeyDownNum && this.state.propsKeyDownNum !== propsKeyDownNum) {
      this.state.propsKeyDownNum = propsKeyDownNum;
      this.handleAccountLogin()
    }
  }
}

export default withRouter(AccountLogin);
